import React from 'react'
import { Icon, Popconfirm } from 'antd'

export const tableColumns = props => [
    {
        title: 'Sender User ID',
        dataIndex: 'author.user_id',
        render: text => <span className="gx-link">{text}</span>
    },
    {
        title: 'Channel ID',
        dataIndex: 'channel.room_id',
        render: text => <span className="gx-link">{text}</span>
    },
    {
        title: 'Type',
        dataIndex: 'type',
        render: type => {
            return type === 'text' ? <Icon type="align-left" /> : <Icon type="file-text" />
        }
    },
    {
        title: 'Content',
        dataIndex: 'text',
        render: (content, row) => {
            if (row.type === 'text') {
                return <span>{content}</span>
            } else {
                return <a href={row.file_url}>{content}</a>
            }
        }
    },
    {
        title: 'Sent at',
        dataIndex: 'inserted_at',
        render: (insertedAt, row) => {
            let d = new Date(insertedAt)
            return (
                <span>
                    {d.toDateString()} - {d.toLocaleTimeString()}
                </span>
            )
        }
    },
    {
        sorter: true,
        sortDirections: ['descend'],
        sortOrder: props.stopSorting ? false : 'descend',
        title: 'Reports',
        dataIndex: 'reports',
        render: reports => <span>{reports}</span>
    },
    {
        title: 'Delete',
        render: (messageId, record) => {
            return (
                <Popconfirm title="Sure to delete?" onConfirm={() => props.handleDelete(record.id)}>
                    <a>
                        <Icon type="delete" />
                    </a>
                </Popconfirm>
            )
        }
    }
]
